'use es6';

import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import makeObjectDefinitionsAdapter from './makeObjectDefinitionsAdapter';
const isAssetFamilySupported = assetFamily => assetFamily === DSAssetFamilies.STANDARD_OBJECT_DEFINITION;
const includeObject = ({
  metaType
}) => metaType === 'HUBSPOT';
export default makeObjectDefinitionsAdapter({
  isAssetFamilySupported,
  includeObject
});